<template>
  <div class="threejsContainer">
    <div class="containerTitle">1-10.粒子系统</div>
    <div ref="container" class="containerBody"></div>
  </div>
</template>

<script>
import * as THREE from 'three';
import {generateScene} from '@/threejsEnv/scene.js';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';

export default {
  data() {
    return {
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      currentMesh: null,
      fullPath: null,
      circleShape: null,
      progress: 0,
      animationId: null
    };
  },
  mounted() {
    //初始化环境
    this.initEnv();
    //创建粒子系统
    this.createParticleSystem();
    // 启动动画
    this.animate();
    // 监听窗口大小变化
    window.addEventListener('resize', this.onWindowResize);
  },
  methods: {
    initEnv(){
      // 初始化场景
      this.scene = generateScene();
      this.scene.background = new THREE.Color(0x000000);

      // 初始化相机
      this.camera = new THREE.PerspectiveCamera(
        75,
        this.$refs.container.clientWidth / this.$refs.container.clientHeight,
        0.1,
        1000
      );
      this.camera.position.set(0, 5, 10);

      // 初始化渲染器
      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.renderer.setSize(
        this.$refs.container.clientWidth,
        this.$refs.container.clientHeight
      );
      this.$refs.container.appendChild(this.renderer.domElement);

      // 添加轨道控制器
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = true;

      // 创建光源
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
      this.scene.add(ambientLight);
      
      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
      directionalLight.position.set(10, 20, 15);
      this.scene.add(directionalLight);
    },
    createParticleSystem() {
      const particleCount = 5000; // 粒子总数

      // 1. 创建粒子几何体（BufferGeometry 性能更优）
      const particleGeometry = new THREE.BufferGeometry();

      // 2. 生成粒子位置数据（Float32Array 存储，每个粒子3个坐标值）
      const positionData = new Float32Array(particleCount * 3);
      for (let i = 0; i < particleCount * 3; i++) {
        // 粒子位置范围：X/Y/Z 轴均在 [-50, 50] 之间
        positionData[i] = (Math.random() - 0.5) * 10;
      }
      
      const colorData = new Float32Array(particleCount * 3);
      for (let i = 0; i < particleCount * 3; i++) {
        colorData[i] = positionData[i] /10*1.2+0.4;
      }

      // 3. 将位置数据添加到几何体属性
      particleGeometry.setAttribute('position',new THREE.BufferAttribute(positionData, 3)); // 3个值为一组（对应X/Y/Z）
      // 4 添加颜色数据
      particleGeometry.setAttribute('color', new THREE.BufferAttribute(colorData, 3));

      // 5. 创建粒子材质（PointsMaterial 专门用于粒子）
      const particleMaterial = new THREE.PointsMaterial({
        size: 0.2,         // 粒子大小
        vertexColors: true,   // 直接启用顶点颜色 
        transparent: true, // 开启透明
        opacity: 0.8       // 透明度
      });

      // 6. 创建粒子系统并添加到场景
      this.particleSystem = new THREE.Points(particleGeometry, particleMaterial);
      this.scene.add(this.particleSystem);
    },
    animate() {
      this.animationId = requestAnimationFrame(this.animate);
      
      this.particleSystem.rotation.x += 0.005;
      this.particleSystem.rotation.y += 0.005;
      this.particleSystem.rotation.z += 0.005;

      this.controls.update();
      this.renderer.render(this.scene, this.camera);
    },
    onWindowResize() {
      const width = this.$refs.container.clientWidth;
      const height = this.$refs.container.clientHeight;

      // 更新相机
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();

      // 更新渲染器
      this.renderer.setSize(width, height);
    }
  },
  beforeDestroy() {
    // 清理动画和事件监听
    cancelAnimationFrame(this.animationId);
    window.removeEventListener('resize', this.onWindowResize);
    
    // 释放资源
    if (this.currentMesh) {
      this.scene.remove(this.currentMesh);
      this.currentMesh.geometry.dispose();
      this.currentMesh.material.dispose();
    }
    
    this.controls.dispose();
    this.renderer.dispose();
    this.renderer.domElement.remove();
  }
};
</script>

<style>
</style>
